import React from 'react';
import { Helmet } from 'react-helmet-async';

const Arrow = () => <span aria-hidden="true">↗</span>;

const hostedProjects = [
  {
    title: 'UFC Market',
    url: 'https://ufc-market.mchami.com',
    description: 'UFC × Polymarket trading dataset, simulator, and dashboard.',
  },
];

const Internal = () => (
  <>
    <Helmet>
      <title>Internal | Mamoun Chami</title>
      <meta name="description" content="Internal directory of hosted projects." />
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <main id="top">
      <section className="intro">
        <p className="kicker">Private</p>
        <h1 id="intro-title">Internal</h1>
        <p className="summary">A private directory of hosted projects.</p>
      </section>

      <section className="content-section" id="projects">
        <h2>Hosted projects</h2>
        <div className="entries">
          {hostedProjects.map((project) => (
            <article className="entry entry-full" key={project.title}>
              <div>
                <h3>
                  <a href={project.url} target="_blank" rel="noreferrer">
                    {project.title} <Arrow />
                  </a>
                </h3>
                <p className="description">{project.description}</p>
                <div className="research-links">
                  <a href={project.url} target="_blank" rel="noreferrer">
                    Open project <Arrow />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  </>
);

export default Internal;
